import React from 'react';
import { Button, ButtonGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

export const ExamChatLink = (props: {
  examId: string;
  token: string;
  dark?: boolean;
}) => {
  return (
    <>
      <ButtonGroup aria-label="TestPlay">
        <OverlayTrigger overlay={<Tooltip>Podgląd badanego </Tooltip>}>
          <Button
            onClick={e => {
              e.stopPropagation();
              window.open(
                `${process.env.REACT_APP_CHAT_APP_URL}/monitor?exam=${props.examId}&token=${props.token}`,
                'blank',
              );
            }}
            variant={props.dark ? 'outline-dark' : 'outline-primary'}
            className="mb-1"
          >
            <Icon.Binoculars className={props.dark ? 'dark-icon' : ''} />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger overlay={<Tooltip>Chat z badanym</Tooltip>}>
          <Button
            onClick={e => {
              e.stopPropagation();
              window.open(
                `${process.env.REACT_APP_CHAT_APP_URL}/consultation?exam=${props.examId}&token=${props.token}`,
                'blank',
              );
            }}
            variant={props.dark ? 'outline-dark' : 'outline-primary'}
            className="mb-1"
          >
            <Icon.ChatDots className={props.dark ? 'dark-icon' : ''} />
          </Button>
        </OverlayTrigger>
      </ButtonGroup>
    </>
  );
};
